const baseData = {
  terminalmanage: {
    terminalInfo: {
      terminalNumber: "Terminal Serial No.",
      terminalBarcode: "OBD code",
      Version: "Firmware",
      SIMCardNumber: "SIM card number",
      founder: "Founder",
      creationTime: "Create time",
      seeHistory: "View history",
      wakeUpTimeInterval: "Sleep Time Interval (Min.)",
      unusualAlarmingValue: "Unusual alarming value",
      IOstate: "MCB Status",
      wakeUpTimeKeepDuration: "Wake-up Time Interval (Min.)",
      abnormalAlarmOff: "Abnormal alarm off",
      ChangeAlarm: "Change alarm",
      turnOff: "Turn off timed wake-up",
      trunOn: "Enable timed wake up",
      bindingState: "Binding state",
      binding: "Binding",
      unbind: "Unbind",
      authorize: "Authorized to",
      searchWidth: {
        width1: "80px",
        width2: "90px",
        width3: "110px",
        width4: "50px"
      },
      tableWidth: "145",
      message: {
        noImportInfo: "No import failure information",
        selectSIM: "Please select the SIM card to export"
      },
      createAndUpdate: {
        create: "Add new OBD",
        update: "Edit OBD",
        error: {
          noSIM: "Please select sim card",
          noTerminal: "Please input terminal SN",
          terminalType: "You can only input eight digits not start with 0",
          noTerminalBarcode: "Please enter the OBD code",
          terminalBarcodeType: "Start with V2A and add 5-7 letters or numbers， 8-10 digits in total",
          noOBDcode: "Please enter the OBD code",
          OBDcodeType: "You can only type 30 characters of A027E00428",
          noExpritTime: "Please select the expiration time"
        },
        labelWidth: "100px"
      }
    },
    SIM: {
      SIMCardNumber: "SIM card number",
      CarrierType: "Carrier type",
      searchWidth: {
        width1: "120px",
        width2: "70px"
      },
      message: "No sim card information failed to import",
      operator: "Operator",
      createAndUpdate: {
        create: "Create",
        update: "Update",
        message: {
          noSim: "Please enter the sim card number",
          simTypeError: "The mobile sim card number is 11 digits",
          unicomError: "Unicom sim card number 20 - digit letters and Numbers",
          selectOperator: "Please select the operator",
          noIccid: "Please enter the ICCID",
          iccidTypeError: "ICCID is 20-bit letters and Numbers"
        },
        labelWidth: "120px"
      }
    },
    terminalchange: {
      terminalNumber: "Terminal number",
      searchWidth: {
        width1: "40px",
        width2: "110px",
        width3: "45px",
        width4: "110px"
      },
      binding: "Binding",
      unbind: "Unbind",
      SIMCardNumber: "SIM card number",
      bindingState: "Binding state",
      founder: "Founder",
      unbundlingPeople: "Unbundling people",
      reason: "Replace the reason",
      tableWidth: {
        terminalNumber: "150",
        bindingState: "130",
        unbundlingPeople: "180"
      },
      msg1: "Please select OBD device number",
      msg2: "Please input the reason for the change"
    }
  },
  configResponse:{
    configName:"Configuration file",
    responseType:"Configuration type",
    responseInit:"Device initialization",
    responsePacketCount:"Package quantity of vehicle operating data",
    responseDistance:"Vehicle running data collection distance Interval",
    responseHeadErrCode:"Identify the cause of the error",
    responseFlameoutVoltage:"Power off voltage setting after flameout(0.1V)",
    responseVersion:"Software version number",
    responseFlameoutWait:"Waiting time after flameout",
    responseDataMode:"Data collection mode",
    responseUpgradeAddress:"Software upgrade address",
    responseHeadErrMsg:"Description of the cause of the error",
    responseBusinessAddress:"Business server address",
    responseLinkHeartbeat:"Link detection heartbeat interval(Second)",
    responseSleepReportInterval:"Periodic reporting interval after sleep(Min)",
    responseHeadCmd:"Respond to commands",
    responseInterval:"Vehicle operating data collection time interval(Second)",
    responseSleepVoltageInterval:"Voltage report interval after sleep(0.1V)",
    responseFlameoutShutdown:"Turn off time setting after flameout(Min)",
    responseAgpsAddress:"AGPS service address",
    createAndUpdate:{
      create: "Added OBD configuration response",
      update: "Edit OBD configuration response",
      error: {
        noConfigName:"Please enter the configuration file name"
      },
      labelWidth: "85px"
    }
  },
  terminalConfig:{    
    terminalId: "Terminal id",
    responseVid:"Vehicle Type",
    responseYear:"Year",
    responseDisplacement:"Displacement",
    responseInit:"Device initialization",
    configName:"Profile name",
    terminalCode:"Terminal code",
    createAndUpdate:{
      binding:"Select terminal binding configuration",
      create: "Added 95OBD device configuration",
      update: "Edit 95OBD device configuration"
    }
  }
} 
export default baseData